module.exports = __webpack_public_path__ + "img/cxq.a94e366.png";